import "es6-promise/auto"
import Vue from "vue"
import App from "./App.vue"
import store from "./store/store.js"
import VueRouter from "vue-router"
import routerConfig from "./route.js"
import Raven from "raven-js"
import RavenVue from "raven-js/plugins/vue"

window.APP_START_TIME = +new Date()

Raven.config("https://7a07a559d4444778ab8ecac75ffcc73c@report.url.cn/sentry/1260", {
  environment: process.env.NODE_ENV,
  release: "1.0.0",
  sampleRate: 0.1,
  dataCallback: data => {
    if (process.env.NODE_ENV != "production") {
      console.error(data)
    }
    return data
  },
  shouldSendCallback: () => {
    return process.env.NODE_ENV == "production"
  }
})
  .addPlugin(RavenVue, Vue)
  .install()

Vue.use(VueRouter)

Vue.config.devtools = process.env.NODE_ENV === "development"

let router = new VueRouter(routerConfig)

Vue.filter("currency", value => {
  return parseFloat(value).toFixed(2)
})

new Vue({
  router: router,
  el: "#app",
  render: h => h(App),
  store: store
})
